import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { ThemeProvider } from "styled-components";

import { invertTheme } from "config/theme";

import UpLanguageSwitch from "../up-language-switch";
import {
  Backdrop,
  Button,
  ConfigurationWrapper,
  ContentWrapper,
  H3,
  Heading,
  HelpWidgetStyle
} from "./styles";

interface UpModalWindowBaseProps {
  children: ReactNode;
  height?: string;
  languageSwitch?: boolean;
  title: ReactNode;
}

interface CloseableModalProps {
  close: () => void;
  closeable?: true;
}

interface NonCloseableModalProps {
  close?: () => void;
  closeable: false;
}

export type UpModalWindowProps = UpModalWindowBaseProps &
  (CloseableModalProps | NonCloseableModalProps);

const UpModalWindow = (props: UpModalWindowProps) => {
  const { title, children, languageSwitch = false, height } = props;
  const closeable = props.closeable !== false;

  const close = () => {
    if (props.closeable !== false) {
      props.close();
    }
  };

  return (
    <div>
      <Backdrop onClick={close} />
      <HelpWidgetStyle />
      <ConfigurationWrapper height={height}>
        <Heading>
          <H3>{title}</H3>
          {closeable ? (
            <Button type="button" onClick={close}>
              <FontAwesomeIcon icon="times" />
            </Button>
          ) : null}
          {languageSwitch ? (
            <ThemeProvider theme={(outerTheme) => ({ ...outerTheme, ...invertTheme })}>
              <UpLanguageSwitch />
            </ThemeProvider>
          ) : null}
        </Heading>
        <ContentWrapper>{children}</ContentWrapper>
      </ConfigurationWrapper>
    </div>
  );
};

export default UpModalWindow;
